import {
  LANDING_AEM_START,
  LANDING_AEM_SUCCESS,
  LANDING_AEM_ERROR,
} from "Constant/RentalCustomer";

const initialState = {
  loading: false,
  data: [],
};

export default function landingDataReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case LANDING_AEM_START:
      return {
        ...state,
        loading: true,
      };
    case LANDING_AEM_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case LANDING_AEM_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
